module.exports = __webpack_public_path__ + "img/27.1ee9c128.jpg";